import type { AiSeverity } from "@/types";

export const CHECKIN_PHASE_LABELS: Record<string, string> = {
  pickup: "Before pickup",
  return: "After ride",
};

export const CHECKIN_PHASE_ICONS: Record<string, string> = {
  pickup: "ri-key-2-line",
  return: "ri-flag-2-line",
};

/** How many stills we send to the AI — enough detail without a huge request. */
export const CHECKIN_MAX_AI_FRAMES = 6;

export const AI_SEVERITY_LABELS: Record<AiSeverity, string> = {
  minor: "Minor",
  moderate: "Moderate",
  severe: "Severe",
};

/** Chip styling per severity, using the palette scale only. */
export const AI_SEVERITY_CHIPS: Record<AiSeverity, string> = {
  minor: "bg-primary-100 text-primary-900",
  moderate: "bg-secondary-100 text-secondary-900",
  severe: "bg-secondary-500 text-background-50",
};

export function phaseLabel(phase: string | null | undefined): string {
  if (!phase) return "Check-in";
  return CHECKIN_PHASE_LABELS[phase] ?? "Check-in";
}

export function checkinClock(total: number): string {
  const safe = Number.isFinite(total) && total > 0 ? total : 0;
  const m = Math.floor(safe / 60)
    .toString()
    .padStart(2, "0");
  const s = Math.floor(safe % 60)
    .toString()
    .padStart(2, "0");
  return `${m}:${s}`;
}

export function formatBytes(bytes: number | null | undefined): string {
  const value = Number(bytes ?? 0);
  if (!value) return "";
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(0)} KB`;
  return `${(value / (1024 * 1024)).toFixed(1)} MB`;
}